import { BaseEnvContribution, rafBasedSto } from "@visactor/vrender-core";

import { createCanvasWithFactory, getMiniAppCanvasOptions, wrapMiniAppContextCanvas } from "./miniapp-canvas";

const TT_CANVAS_BRIDGE_ERROR = "TT canvas bridge is unavailable. VRender tt env requires envParams.canvasFactory, a Stage canvas object, or a tt runtime that exposes createCanvasContext(id).";

function getTTRuntime(params) {
    var _a, _b, _c;
    try {
        return null !== (_b = null !== (_a = null == params ? void 0 : params.tt) && void 0 !== _a ? _a : null == params ? void 0 : params.runtime) && void 0 !== _b ? _b : "undefined" != typeof tt ? tt : void 0;
    } catch (_d) {
        return null !== (_c = null == params ? void 0 : params.tt) && void 0 !== _c ? _c : null == params ? void 0 : params.runtime;
    }
}

function getTTPixelRatio(params, runtime = getTTRuntime(params)) {
    var _a, _b, _c, _d;
    return null !== (_d = null !== (_a = null == params ? void 0 : params.pixelRatio) && void 0 !== _a ? _a : null === (_c = null === (_b = null == runtime ? void 0 : runtime.getSystemInfoSync) || void 0 === _b ? void 0 : _b.call(runtime)) || void 0 === _c ? void 0 : _c.pixelRatio) && void 0 !== _d ? _d : 1;
}

export class TTEnvContribution extends BaseEnvContribution {
    constructor() {
        super(), this.type = "tt", this.supportEvent = !0, this.canvasMap = new Map, this.ttEnvParams = {}, 
        this.supportsTouchEvents = !0;
        try {
            this.supportsPointerEvents = !!globalThis.PointerEvent, this.supportsMouseEvents = !!globalThis.MouseEvent;
        } catch (err) {
            this.supportsPointerEvents = !1, this.supportsMouseEvents = !1;
        }
        this.applyStyles = !0;
    }
    configure(service, params = {}) {
        service.env === this.type && (service.setActiveEnvContribution(this), this.ttEnvParams = params);
    }
    loadImage(url) {
        return Promise.resolve({
            data: url,
            loadState: "success"
        });
    }
    loadSvg(url) {
        return Promise.reject();
    }
    createCanvas(params) {
        var _a;
        const envParams = this.ttEnvParams, runtime = getTTRuntime(envParams), dpr = null !== (_a = params.dpr) && void 0 !== _a ? _a : getTTPixelRatio(envParams, runtime), factoryCanvas = createCanvasWithFactory(params, dpr, this.canvasMap, envParams.canvasFactory);
        if (factoryCanvas) return factoryCanvas;
        const options = getMiniAppCanvasOptions(params, dpr, !1);
        if (null == options.id || "function" != typeof (null == runtime ? void 0 : runtime.createCanvasContext)) throw new Error(TT_CANVAS_BRIDGE_ERROR);
        const canvas = wrapMiniAppContextCanvas(runtime.createCanvasContext(options.id), options);
        return this.canvasMap.set(options.id, canvas), canvas;
    }
    createOffscreenCanvas(params) {}
    releaseCanvas(canvas) {}
    getDevicePixelRatio() {
        return getTTPixelRatio(this.ttEnvParams);
    }
    getRequestAnimationFrame() {
        return function(callback) {
            return rafBasedSto.call(callback);
        };
    }
    getCancelAnimationFrame() {
        return h => {
            rafBasedSto.clear(h);
        };
    }
    addEventListener(type, listener, options) {
        return null;
    }
    removeEventListener(type, listener, options) {
        return null;
    }
    dispatchEvent(event) {
        return null;
    }
    getElementById(str) {
        return this.canvasMap.get(str);
    }
    getRootElement() {
        return null;
    }
    getDocument() {
        return null;
    }
    release(...params) {}
    mapToCanvasPoint(event) {
        var _a;
        return null === (_a = null == event ? void 0 : event.type) || void 0 === _a || _a.startsWith("mouse"), 
        event;
    }
}
//# sourceMappingURL=tt-contribution.js.map
